/**
 * `listItems(clientId)` — optional `clientId` (null when listing global palettes).
 * `palettes(pagination)` — optional `PaginationInput`; omit variables.pagination for unbounded / default server behavior (used by chart/editor bulk fetch).
 * Item fields `reportUsage` / `themeUsage` are Int in schema; treat null as zero in mapping.
 */
export const listPalettes = `
	query listPalettes($clientId: String, $pagination: PaginationInput) {
		listItems(clientId: $clientId) {
			palettes(pagination: $pagination) {
				items {
					paletteId
					label
					light
					dark
					reportUsage
					themeUsage
				}
				pagination {
					limit
					pageSize
					totalItems
					page
				}
			}
		}
	}
`;
